import { useAuth0 } from '@auth0/auth0-react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import {
  ADMIN_DOWNLOADS_ROUTE,
  INSIGHTS_ROUTE,
  PARTNERS_ROUTE,
  REPORTING_ROUTE,
} from 'utils/constants/admin'
import { Flex, HeaderNavLink, MobileMenu } from '..'
import { useWindowWidth } from '../../hooks'
import { LogoAdmin } from '../svg'
import { AuthButton } from './AuthButton'

const ADMIN_NAV_BREAKPOINT = 820

const NavLinks = ({ handleClick }: { handleClick?: () => void }) => {
  const { t } = useTranslation()

  return (
    <Nav>
      <HeaderNavLink to={PARTNERS_ROUTE} onClick={handleClick}>
        {t('partners.title')}
      </HeaderNavLink>
      <HeaderNavLink to={REPORTING_ROUTE} onClick={handleClick}>
        {t('reporting.title')}
      </HeaderNavLink>
      <HeaderNavLink to={INSIGHTS_ROUTE} onClick={handleClick}>
        {t('insights.insights')}
      </HeaderNavLink>
      <HeaderNavLink to={ADMIN_DOWNLOADS_ROUTE} onClick={handleClick}>
        {t('admin_documents.title')}
      </HeaderNavLink>
    </Nav>
  )
}

const Header = () => {
  const { isAuthenticated } = useAuth0()
  const buttonVariant = isAuthenticated ? 'outline' : 'solid'
  const location = useLocation()
  const isLoginRoute = location.pathname === '/login'
  const { isMobile, isAboveMobile } = useWindowWidth({
    mobileBreakpoint: ADMIN_NAV_BREAKPOINT,
  })

  return (
    <StyledHeader>
      <Link to="/">
        <LogoAdmin />
      </Link>

      {isAboveMobile && isAuthenticated && <NavLinks />}

      <Flex marginLeft="16px" style={{ flexShrink: 0 }}>
        {isAboveMobile && !isLoginRoute && (
          <AuthButton color="light" variant={buttonVariant} width="adjustable" />
        )}
        {isMobile && isAuthenticated && (
          <MobileMenu variant="brand">
            {onClose => (
              <>
                <NavLinks handleClick={onClose} />
                <Flex onClick={onClose}>
                  <AuthButton color="light" variant="outline" width="adjustable" />
                </Flex>
              </>
            )}
          </MobileMenu>
        )}
      </Flex>
    </StyledHeader>
  )
}

const StyledHeader = styled.header`
  margin: 0 auto;
  background-color: var(--theme-primary);
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: var(--header-height);
  padding: 0 24px 0 32px;

  a {
    white-space: nowrap;

    &:first-child {
      margin-right: 40px;
    }
  }

  .keyboard-outline & *:focus {
    box-shadow: none;
  }
`

const Nav = styled.nav`
  display: flex;
  flex-direction: column;

  @media (min-width: ${ADMIN_NAV_BREAKPOINT}px) {
    flex-direction: row;
    width: 100%;
    align-items: center;
    padding: 0 16px;
  }
`

export { Header }
